import styled from 'styled-components'

export const Page = styled.main`
  width: 100%;
  min-height: 100vh;
  padding: 110px 32px 48px;
  background: ${p => p.theme.palette.colors.background};
  @media(max-width: 700px) { padding: 96px 16px 32px; }
`

export const Header = styled.header`
  display: flex;
  justify-content: space-between;
  margin-bottom: 28px;
`

export const Title = styled.h1`
  margin: 0 0 6px;
  color: ${p => p.theme.palette.colors.text};
  font-family: Gilroy;
  font-size: 38px;
`

export const Subtitle = styled.p`
  margin: 0;
  color: ${p => p.theme.palette.colors.muted};
  font-family: Lato;
`

export const State = styled.section`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 14px;
  padding: 32px;
  border: 1px solid ${p => p.theme.palette.colors.borderSoft};
  border-radius: 18px;
  background: ${p => p.theme.palette.colors.surfaceElevated};
`
